import { useState, useEffect } from "react";

interface ReservationsTabProps {
  onFrameChange?: (range: string) => void;
  selectedFrame?: string;
}

const ReservationsTab: React.FC<ReservationsTabProps> = ({
  onFrameChange,
  selectedFrame,
}) => {
  const [selected, setSelected] = useState<string>(selectedFrame || "New");

  useEffect(() => {
    if (selectedFrame) {
      setSelected(selectedFrame);
    }
  }, [selectedFrame]);

  const handleSelect = (option: string) => {
    setSelected(option);
    onFrameChange?.(option);
  };

  const getButtonClass = (option: string) =>
    selected === option
      ? "text-black font-bold border-b-[3px] -mb-2 py-[0.5px] border-black dark:text-white dark:bg-gray-800"
      : "text-black font-[300] dark:text-gray-400";

  return (
    <div className="w-full box-sizing:border-box border-b-4">
      <div className="flex w-full items-center gap-1.5 dark:bg-gray-900">
        <button
          onClick={() => handleSelect("New")}
          className={`px-3 py-2 h-9 font-medium text-sm whitespace-nowrap hover:text-gray-900 dark:hover:text-white ${getButtonClass(
            "New"
          )}`}
        >
          New
        </button>
        <button
          onClick={() => handleSelect("History")}
          className={`px-3 py-2 h-9 font-medium text-sm whitespace-nowrap text-theme-sm hover:text-gray-900 dark:hover:text-white ${getButtonClass(
            "History"
          )}`}
        >
          History
        </button>
      </div>
    </div>
  );
};

export default ReservationsTab;
